import { avgEngagementRateHistoryConfig } from '@/lib/analytics/charts/twitter/avgEngagementRateHistory';
//charts
import { followerGrowthHistoryConfig } from '@/lib/analytics/charts/twitter/followerGrowthHistory';
import { likesHistoryConfig } from '@/lib/analytics/charts/twitter/likesHistory';
import { retweetsHistoryConfig } from '@/lib/analytics/charts/twitter/retweetsHistory';
import { avgEngagementRatePerTweetConfig } from '@/lib/analytics/kpis/twitter/avgEngagementRatePerTweet';
import { followersEvolutionConfig } from '@/lib/analytics/kpis/twitter/followersEvolution';
import { followersEvolutionPercentageConfig } from '@/lib/analytics/kpis/twitter/followersEvolutionPercentage';
import { impressionsConfig } from '@/lib/analytics/kpis/twitter/impressions';
import { likesReceivedConfig } from '@/lib/analytics/kpis/twitter/likesReceived';
import { retweetsConfig } from '@/lib/analytics/kpis/twitter/retweets';
//kpis
import { totalFollowersConfig } from '@/lib/analytics/kpis/twitter/totalFollowers';
import { totalRepliesReceivedConfig } from '@/lib/analytics/kpis/twitter/totalRepliesReceived';
import { totalRepliesSentConfig } from '@/lib/analytics/kpis/twitter/totalRepliesSent';
import { totalTweetsConfig } from '@/lib/analytics/kpis/twitter/totalTweets';
//widgets
import { mostRecentTweetsConfig } from '@/lib/analytics/widget/twitter/mostRecentTweetsConfig';
import { ORIENTATION_VERTICAL } from '@/lib/gridElements/orientation';
import { SIZE_33 } from '@/lib/gridElements/size';

export const OverviewTwitter = [
    { ...totalFollowersConfig, size: SIZE_33 },
    { ...followersEvolutionConfig, size: SIZE_33 },
    { ...followersEvolutionPercentageConfig, size: SIZE_33 },
    totalTweetsConfig,
    totalRepliesSentConfig,
    impressionsConfig,
    avgEngagementRatePerTweetConfig,
    followerGrowthHistoryConfig,
    avgEngagementRateHistoryConfig,
    mostRecentTweetsConfig,
    { ...likesReceivedConfig, size: SIZE_33 },
    { ...retweetsConfig, size: SIZE_33 },
    { ...totalRepliesReceivedConfig, size: SIZE_33, orientation: ORIENTATION_VERTICAL },
    likesHistoryConfig,
    retweetsHistoryConfig
];

export const requestTwitterParams = [
    // TwitterAccountMetrics
    ['followers', 'followers_evolution', 'followers_evolution_percentage', 'followers_growth'],
    // TwitterMedia
    [
        'tweets',
        'replies',
        'impressions',
        'average_engagement_rate_per_tweet',
        'average_engagement_rate_history',
        'likes',
        'retweets',
        'reply_tweets',
        'likes_history',
        'retweets_history'
    ]
];
